import React from 'react'

type Props = {
  children: React.ReactNode
}
import { NavigationContainer } from '@react-navigation/native'
import navigationRef from '@beatgig/navigation/service/ref'

export function NavigationProvider({ children }: Props) {
  return (
    <NavigationContainer
      documentTitle={{
        enabled: false,
      }}
      ref={navigationRef}
    >
      {children}
    </NavigationContainer>
  )
}
